const host = window.location.hostname;

export const environmentTypes = {
  STAGING: "staging",
  PRODUCTION: "production",
};

export const getDomain = () => {
  switch (host) {
    case "localhost":
    case "127.0.0.1":
      return "localhost";
    case "shreehkj.netlify.app":
      return ".netlify.app";
    default:
      return "localhost";
  }
};

export const cookieOptions = {
  path: "/",
  // domain: getDomain(),
};

export const getEnvironment = () => {
  switch (host) {
    case "localhost":
      return environmentTypes.STAGING;

    default:
      return environmentTypes.STAGING;
  }
};

// Set a cookie
export const setCookie=(name, object, daysToExpire)=> {
  var expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + daysToExpire);

  var cookieString = name + "=" + encodeURIComponent(JSON.stringify(object)) + "; expires=" + expirationDate.toUTCString() + "; path=/";
  document.cookie = cookieString;
}
// Get a cookie
export const getCookie=(name)=> {
  var cookies = document.cookie.split("; ");
  for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].split("=");
      if (cookie[0] === name) {
          return JSON.parse(decodeURIComponent(cookie[1]));
      }
  }
  return null;
}